<template>
  <IconWrapper name="download" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2616 15.403C11.2706 15.414 11.2816 15.424 11.2916 15.434C11.3766 15.521 11.4746 15.588 11.5796 15.637L11.5816 15.638C11.5996 15.646 11.6176 15.654 11.6366 15.661C11.7396 15.701 11.8496 15.725 11.9666 15.729H11.9696C11.9776 15.73 11.9866 15.73 11.9946 15.73H12.0006C12.0156 15.73 12.0306 15.729 12.0446 15.729H12.0466C12.1636 15.723 12.2756 15.698 12.3796 15.655C12.3966 15.649 12.4146 15.641 12.4316 15.632H12.4336C12.5336 15.584 12.6266 15.518 12.7086 15.436C12.7196 15.425 12.7306 15.414 12.7406 15.403L16.3196 11.55C16.6956 11.146 16.6726 10.513 16.2676 10.137C15.8636 9.761 15.2306 9.785 14.8546 10.189L13.0006 12.184V4.25C13.0006 3.697 12.5536 3.25 12.0006 3.25C11.4486 3.25 11.0006 3.697 11.0006 4.25V12.184L9.14661 10.189C8.77061 9.784 8.13761 9.76 7.73361 10.137C7.32861 10.513 7.30561 11.146 7.68161 11.55L11.2616 15.403Z"
        fill="#1B1B1E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 14.2891C19.448 14.2891 19 14.7371 19 15.2891V16.9391C19 18.2131 17.964 19.2491 16.69 19.2491H7.311C6.037 19.2491 5 18.2131 5 16.9391V15.2891C5 14.7371 4.553 14.2891 4 14.2891C3.448 14.2891 3 14.7371 3 15.2891V16.9391C3 19.3151 4.934 21.2491 7.311 21.2491H16.69C19.066 21.2491 21 19.3151 21 16.9391V15.2891C21 14.7371 20.552 14.2891 20 14.2891Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
